import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled, Typography } from '@mui/material';

export const OrderInfoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  fontSize: '12px',
  lineHeight: 1.33,
  letterSpacing: 'normal',
  textAlign: 'center',
  color: theme.palette.colors.label,

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    gap: '8px',
  },
}));

export const ValueContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '10px',
}));

export const IconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '18px',
  color: theme.palette.colors.mainFocused,
}));

export const ValueStyled = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 'bold',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onPrimaryBackground,
}));
